import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import {
  PermissionDenied,
  PermissionEnum,
  Select,
  SelectSize,
  Tabs,
} from '@ui/src';
import { useAppSelector } from '@store';

import ROUTES from '../../routes';

import cn from './styles.module.css';

const FintracReports = () => {
  const match = useMatch(ROUTES.FINTRAC_REPORTS);
  const { activePermissions } = useAppSelector((state) => state.root);

  const navigate = useNavigate();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.REGULATORY_REPORT_FINTRAC_LIST)
    ) {
      navigate(ROUTES.FINTRAC_EFTR);
    }
  }, [match, activePermissions]);

  let content;

  if (
    !activePermissions?.includes(PermissionEnum.REGULATORY_REPORT_FINTRAC_LIST)
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <div className={cn.fintracTitle}>
          External reports
          <div className={cn.fintracReportSelectWrapper}>
            <Select
              name="fintracReport"
              value="fintrac"
              list={[
                {
                  name: 'Fintrac',
                  value: 'fintrac',
                },
              ]}
              size={SelectSize.SMALL}
              disabled
              fullWidth
            />
          </div>
        </div>
        <div className={cn.fintracTabsWrapper}>
          <Tabs
            tabs={[
              {
                name: 'EFTR',
                path: ROUTES.FINTRAC_EFTR,
              },
              {
                name: 'LVCTR',
                path: ROUTES.FINTRAC_LVCTR,
              },
            ]}
            enableRouting
          />
        </div>
        <Outlet />
      </>
    );
  }

  return content;
};

export default FintracReports;
